import { render, staticRenderFns } from "./ConsentModal.vue?vue&type=template&id=3ce48a6d&scoped=true&"
import script from "./ConsentModal.vue?vue&type=script&lang=js&"
export * from "./ConsentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce48a6d",
  null
  
)

export default component.exports